<div class="row">
  <div
    [class.col-12]="column.type === TableConfigColumnTypeEnum.DATE || column.type === TableConfigColumnTypeEnum.CARBON_IMMUTABLE"
    [class.col-6]="column.type !== TableConfigColumnTypeEnum.DATE && column.type !== TableConfigColumnTypeEnum.CARBON_IMMUTABLE">
    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.STRING  || column.type === TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA">
      <app-form-group
        [formControl]="$any(inputFormControl)"
        type="text"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) | translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
      ></app-form-group>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.BOOL">
      <app-multi-select-with-static-options
        [small]="small"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="false"
        [name]="column.name"
        [selectOptions]="[
                { value: 'enums.bool.1' | translate,key: '1'},
                { value: 'enums.bool.0' | translate,key: '0'}
                ]"
      ></app-multi-select-with-static-options>
    </ng-container>

    <ng-container
      *ngIf="[TableConfigColumnTypeEnum.MODEL_STATE_ENUM , TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE].includes($any(column.type))">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="ModelStateEnum"
        translateKey="modelStateEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.INT">
      <app-int-filter
        *ngIf="$any(inputFormControl)"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [small]="small"
        [inline]="false"
      ></app-int-filter>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.FLOAT">
      <app-int-filter
        *ngIf="$any(inputFormControl)"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [small]="small"
        [inline]="false"
      ></app-int-filter>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.DATE">
      <app-date-filter
        *ngIf="$any(inputFormControl)"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [inline]="false"
        [multiLine]="false"
      ></app-date-filter>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.CARBON_IMMUTABLE">
      <app-date-filter
        *ngIf="$any(inputFormControl)"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [inline]="false"
        [multiLine]="false"
      ></app-date-filter>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_STATE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="PatientStateEnum"
        translateKey="patientStateEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.EMAIL_TYPE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="EmailTypeEnum"
        translateKey="emailTypeEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_LANGUAGE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"

        [multi]="true"
        [enum]="PatientLanguageEnum"
        translateKey="patientLanguageEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.FK_EMAIL">
      <app-multi-select-with-service-id-array
        [searchOnField]="'title'"
        [formControl]="$any(inputFormControl)"
        [service]="emailService"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="title"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.ARRAY">
      <code>{{ column.type }} filter not implemented on column {{ column.name }} </code>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.DIAGNOSIS_RESOURCE">
      <app-multi-select-with-service-id-array
        [small]="small"
        [searchOnField]="'title'"
        [sort]="'-created_at'"
        [service]="diagnosisService"
        [filters]="{'is_category': 'false'}"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_ORIGIN_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"

        [multi]="true"
        [enum]="PatientOriginEnum"
        translateKey="patientOriginEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.FK_DIAGNOSIS">
      <app-multi-select-with-service-id-array
        [searchOnField]="'title'"
        [formControl]="$any(inputFormControl)"
        [service]="diagnosisService"
        [filters]="{'is_category': 'false'}"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="title"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.FK_DIAGNOSIS_CATEGORY">
      <app-multi-select-with-service-id-array
        [searchOnField]="'title'"
        [formControl]="$any(inputFormControl)"
        [service]="diagnosisService"
        [filters]="{'is_category': 'true'}"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="title"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_GENDER_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="PatientGenderEnum"
        translateKey="patientGenderEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.REDUCED_USER_RESOURCE">
      <app-multi-select-with-service
        [small]="small"
        [searchOnField]="'name'"
        [sort]="'-created_at'"
        [selectionMode]="'single_id'"
        [service]="userService"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_BACKOFFICE_USER">
      <app-multi-select-with-service
        [small]="small"
        [searchOnField]="'name'"
        [sort]="'-created_at'"
        [selectionMode]="'single_id'"
        [service]="addableBackofficeUserService"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_DOCTOR">
      <app-multi-select-with-service
        [small]="small"
        [searchOnField]="'name'"
        [sort]="'-created_at'"
        [selectionMode]="'single_id'"
        [service]="addableDoctorService"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.INQUIRY_STATE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="InquiryStateEnum"
        translateKey="inquiryStateEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.FK_PATIENT">
      <app-multi-select-with-service-id-array
        [searchOnField]="'name'"
        [formControl]="$any(inputFormControl)"
        [service]="patientService"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="id"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.FK_USER">
      <app-multi-select-with-service-id-array
        [searchOnField]="'name'"
        [formControl]="$any(inputFormControl)"
        [service]="userService"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="id"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container
      *ngIf="column.type === TableConfigColumnTypeEnum.COMPUTED_TEAM_LEADER">
      <app-multi-select-with-service-id-array
        [searchOnField]="'name'"
        [formControl]="$any(inputFormControl)"
        [service]="addableTeamLeadersService"
        size="sm"
        [name]="column.name"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [small]="small"
        sort="id"
      ></app-multi-select-with-service-id-array>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_CATEGORY_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="ProcessCategoryEnum"
        translateKey="processCategoryEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_ROLE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="ProcessRoleEnum"
        translateKey="processRoleEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_PRIORITY_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="ProcessPriorityEnum"
        translateKey="processPriorityEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.QM_PROCESS_COMPLEXITY_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="ProcessComplexityEnum"
        translateKey="processComplexityEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.FK_PROCESS">
      <app-multi-select-with-service
        [small]="small"
        [searchOnField]="'ext_id'"
        [sort]="'ext_id'"
        [selectionMode]="'single_id'"
        [service]="processService"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.PATIENT_SOURCE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
      [enum]="PatientSourceEnum"
      translateKey="patientSourceEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.TIME_TRACKING_ENTRY_TYPE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="TimeTrackingEntryTypeEnum"
        translateKey="timeTrackingEntryTypeEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="TimeTrackingAbsenceRequestStateEnum"
        translateKey="timeTrackingAbsenceRequestStateEnum"
      ></app-multi-select-enum>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.FK_TIME_TRACKING_EMPLOYEE">
      <app-multi-select-with-service
        [small]="small"
        [searchOnField]="'name'"
        [sort]="'id'"
        [selectionMode]="'single_id'"
        [service]="timeTrackingEmployeeService"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
      ></app-multi-select-with-service>
    </ng-container>

    <ng-container *ngIf="column.type === TableConfigColumnTypeEnum.GERMAN_STATE_ENUM">
      <app-multi-select-enum
        [small]="small"
        [name]="column.name"
        [formControl]="$any(inputFormControl)"
        [placeholder]="(('tables.' + tableConfig?.id + '.' + column.name) |translate) + ($any(inputFormControl).hasValidator(Validators.required) ? ' *': '')"
        [multi]="true"
        [enum]="GermanStateEnum"
        translateKey="germanStateEnum"
      ></app-multi-select-enum>
    </ng-container>

    <div class="alert alert-warning small"
         *ngIf="![
                          TableConfigColumnTypeEnum.CARBON_IMMUTABLE,
                          TableConfigColumnTypeEnum.STRING,
                          TableConfigColumnTypeEnum.INT,
                          TableConfigColumnTypeEnum.MONEY,
                          TableConfigColumnTypeEnum.ARRAY,
                          TableConfigColumnTypeEnum.BOOL,
                          TableConfigColumnTypeEnum.MODEL_STATE_STATE_MACHINE,
                          TableConfigColumnTypeEnum.MODEL_STATE_ENUM,
                          TableConfigColumnTypeEnum.MULTI_LANGUAGE_ATTRIBUTE_DATA,
                          TableConfigColumnTypeEnum.DATE,
                          TableConfigColumnTypeEnum.PATIENT_STATE_ENUM,
                          TableConfigColumnTypeEnum.EMAIL_TYPE_ENUM,
                          TableConfigColumnTypeEnum.PATIENT_LANGUAGE_ENUM,
                          TableConfigColumnTypeEnum.DIAGNOSIS_RESOURCE,
                          TableConfigColumnTypeEnum.FK_EMAIL,
                          TableConfigColumnTypeEnum.DIAGNOSIS_RESOURCE,
                          TableConfigColumnTypeEnum.PATIENT_ORIGIN_ENUM,
                          TableConfigColumnTypeEnum.FK_DIAGNOSIS,
                          TableConfigColumnTypeEnum.FK_DIAGNOSIS_CATEGORY,
                          TableConfigColumnTypeEnum.PATIENT_GENDER_ENUM,
                          TableConfigColumnTypeEnum.REDUCED_USER_RESOURCE,
                          TableConfigColumnTypeEnum.COMPUTED_BACKOFFICE_USER,
                          TableConfigColumnTypeEnum.COMPUTED_DOCTOR,
                          TableConfigColumnTypeEnum.INQUIRY_STATE_ENUM,
                          TableConfigColumnTypeEnum.FK_PATIENT,
                          TableConfigColumnTypeEnum.FK_USER,
                          TableConfigColumnTypeEnum.COMPUTED_TEAM_LEADER,
                          TableConfigColumnTypeEnum.QM_PROCESS_CATEGORY_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_ROLE_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_PRIORITY_ENUM,
                          TableConfigColumnTypeEnum.QM_PROCESS_COMPLEXITY_ENUM,
                          TableConfigColumnTypeEnum.FK_PROCESS,
                          TableConfigColumnTypeEnum.PATIENT_SOURCE_ENUM,
                          TableConfigColumnTypeEnum.TIME_TRACKING_ENTRY_TYPE_ENUM,
                          TableConfigColumnTypeEnum.TIME_TRACKING_ABSENCE_REQUEST_STATE_ENUM,
                          TableConfigColumnTypeEnum.FK_TIME_TRACKING_EMPLOYEE,
                          TableConfigColumnTypeEnum.FLOAT,
                          TableConfigColumnTypeEnum.GERMAN_STATE_ENUM,
                          ].includes($any(column.type))
                      && ['local', 'local-stage'].includes(environment.env_name)">

      (table-filter-input) Type not implemented: <code>{{ column.type }}</code> (column: {{ column | json }})
    </div>

  </div>

</div>
